import React from "react";
import { ToggleTagControl } from "./ToggleTagControl";

export class TagSelectionDataControl extends React.Component {
    constructor(props) {
        super(props);

        if (!this.props.dataManager) {
            throw new Error("ControlDataManager Property is required");
        }

        if (!this.props.propertyName) {
            throw new Error("PropertyName Property is required");
        }

        this.state = {
            items: null,
            selectedItems: new Array()
        }

        this.dataManager = this.props.dataManager;
        this.dataManager.register(this);
        this.metaData = null;
        this.cache = new Cache('tag-management-control', 60);        
    }


    componentDidMount() {
        this.dataManager.bindControl(this.props.propertyName);
    }

    componentWillUnmount() {
        this.dataManager.unbindControl(this.props.propertyName);
    }

    init(metaData) {
        var self = this
        return new Promise(function (resolve, reject) {
            self.metaData = metaData;

            self.getDataSourceItems()
                .then(data => {
                    console.log(data);
                    self.setState({
                        items: data
                    });
                    resolve(self);
                })            
        });
    }

    getDataSourceItems() {
        var self = this;
        return new Promise(function (resolve, reject) {
            self.dataManager.getDataSourceItems(self.metaData.dataSourceData.name)
                .then(items => {
                    resolve(items);
                })
                .catch(error => reject(error));
        });
    }

    setValue(value) {
        var self = this;
        console.log("VALUE", value);
        var result = [];
        if (value.length > 0) {
            value.forEach(function (v) {
                result.push(v.dataObject2);
            });
        }
        console.log("VALUES", result);

        this.setState({
            selectedItems: result
        });

        this.dataManager.reportChange(result, this);
    }

    getValue() {
        var result = [];
        var selectedItems = this.state.selectedItems && this.state.selectedItems.length > 0 ? this.state.selectedItems : new Array();
        selectedItems.forEach(function (item) {
            var dto = {
                dataObject2: item,
                dataObject2Id: item.id
            };
            result.push(dto);
        });

        return result;
    }

    isInputValid() {
        var result = true;
        if (this.metaData && this.metaData.validationData && this.metaData.validationData.required == true) {
            if (!this.state.selectedItems || this.state.selectedItems.length == 0) {
                result = false;
            }
        }
        return result;
    }

    isSelected(item) {
        var selectedItem = this.state.selectedItems.find(e => e.id === item.id);
        return selectedItem ? true : false;
    }

    onToggle(item) {
        var selectedItems = this.state.selectedItems;
        var idx = selectedItems.findIndex(e => e.id === item.id);

        if (idx >= 0) {
            selectedItems.splice(idx, 1);
        }
        else {
            selectedItems.push(item);
        }

        this.setState({
            selectedItems: selectedItems
        });
    }


    render() {
        return (
            <div className='tagSelectionDataControl'>
                {this.state.items &&
                    <div>
                        {this.state.items.map((item, idx) => {
                            return (
                                <ToggleTagControl item={item} selected={this.isSelected(item)} onClick={() => {this.onToggle(item)} } />
                            )
                        })}
                    </div>
                }
            </div>
            )
    }
}


